import styled from "styled-components";
import { CouponTicket, Copy } from "ui";
import { theme } from "ui/themes";

interface CouponNameProps {
  couponNameLengthGreaterThanTen?: boolean;
}

export const BoxCouponsContainer = styled.section`
  background: none;
  width: 100%;
  max-width: 444px;
`;

export const BoxCouponsContent = styled.div`
  display: flex;
  max-width: 37.85rem;
  flex-direction: column;
  gap: 1.35rem;
  min-height: 100%;
`;

export const BoxCouponsTitle = styled.h3`
  color: ${theme.colors.neutral["720"]};
  font-family: ${theme.typography.fontFamily.chivo};
  font-size: 1.4125rem;
  font-weight: ${theme.typography.fontWeight["500"]};
`;

export const CouponCardContainer = styled.section`
  border-radius: 10px;
  border: 1.5px solid ${theme.colors.neutral["105"]};
  background: ${theme.colors.neutral["white-075"]};
  width: 100%;
  height: 8.5rem;
  padding: 0 0.675rem;

  @media (min-width: 768px) and (max-width: 1144px) {
    padding: 0;
  }

  @media ${theme.device.desktopFirst.mobileM} {
    height: auto;
  }
`;

export const CouponCardContent = styled.div`
  display: flex;
  gap: 3.5rem;
  align-items: center;
  align-self: stretch;

  padding: 0rem 0.65rem 0rem 1.35rem;
  min-height: 100%;

  @media ${theme.device.desktopFirst.laptop} {
    padding: 0;
    gap: 1rem;
  }

  @media ${theme.device.desktopFirst.tabletXL} {
    padding: 0rem 0.65rem 0rem 0.35rem;
  }

  @media ${theme.device.desktopFirst.tablet} {
    padding: 0rem 0.65rem 0rem 1.35rem;
  }

  @media ${theme.device.desktopFirst.mobileL} {
    padding: 0rem 0.65rem 0rem 0.35rem;
    gap: 1.5rem;
  }

  @media ${theme.device.desktopFirst.mobileM} {
    padding: 0.65rem;
    flex-direction: column;
  }
`;

export const CouponDiscountWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 96px;
`;

export const CouponDiscount = styled.span`
  color: ${theme.colors.primary["350"]};
  font-family: ${theme.typography.fontFamily.chivo};
  font-size: 2rem;
  font-weight: ${theme.typography.fontWeight["600"]};

  @media (min-width: 768px) and (max-width: 1144px) {
    font-size: 1.75rem;
  }
`;

export const CouponDiscountDescription = styled.p`
  color: ${theme.colors.neutral["999"]};
  font-family: ${theme.typography.fontFamily.chivo};
  font-size: 0.835rem;
  font-weight: ${theme.typography.fontWeight["400"]};
  text-align: center;
`;

export const CouponNameWrapper = styled.div``;

export const CouponTicketIconWrapper = styled.div`
  position: relative;
  bottom: 22px;
  right: 6px;
`;

export const CouponTicketIcon = styled(CouponTicket).attrs({
  width: "100%",
})`
  min-width: 184px;
`;

export const CouponTicketWrapper = styled.div`
  min-width: 184px;
  max-height: 40px;

  @media (min-width: 768px) and (max-width: 1144px) {
    min-width: auto;
  }
`;

export const CouponName = styled.span<CouponNameProps>`
  z-index: 2;
  position: relative;
  top: 6px;
  left: ${({ couponNameLengthGreaterThanTen }) =>
    couponNameLengthGreaterThanTen
      ? "calc(100% - calc(37.25% + calc(196px / 2)))"
      : "calc(100% - calc(23.8% + calc(196px / 2)))"};

  color: ${theme.colors.neutral["white-075"]};
  font-family: ${theme.typography.fontFamily.chivo};
  font-size: 1.15rem;
  font-weight: ${theme.typography.fontWeight["400"]};
  text-align: center;
  user-select: none;
`;

export const CouponNameBold = styled.strong`
  color: ${theme.colors.neutral["white-075"]};
  font-family: ${theme.typography.fontFamily.chivo};
  font-size: 1.35rem;
  font-weight: ${theme.typography.fontWeight["600"]};
  text-align: center;
  text-transform: uppercase;
  user-select: none;
`;

export const CopyCouponContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  cursor: pointer;
`;

export const CopyCouponIcon = styled(Copy)``;

export const CopyCouponText = styled.span`
  color: ${theme.colors.primary["350"]};
  font-family: ${theme.typography.fontFamily.chivo};
  font-size: 1.15rem;
  font-weight: ${theme.typography.fontWeight["500"]};
`;
